class FormLoading {
	constructor(element, options) {
		this.element = element;
		this.options = options;
		this.watch();
	}

	watch() {
		this.element.addEventListener("submit", this.applyLoadingState.bind(this));
	}

	applyLoadingState() {
		this.element.dataset[this.options.dataKey] = this.options.dataValue;
	}
}

FormLoading.DEFAULTS = {
	dataKey: 'state',
	dataValue: 'loading'
};
export default FormLoading;



// WEBPACK FOOTER //
// ./project/client/src/core/plugins/jquery__form-loading/form-loading.js